import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import CloseIcon from "@mui/icons-material/Close";

const SearchInput = ({ onSearch }) => {
  const [active, setActive] = useState(false);
  const [query, setQuery] = useState("");
  const inputRef = useRef(null);

  // Focus the input when search becomes active
  useEffect(() => {
    if (active && inputRef.current) {
      inputRef.current.focus();
    }
  }, [active]);

  //   const handleIconClick = () => {
  //     setActive(true);
  //   };

  const handleChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    onSearch(value);
  };

  const handleBlur = () => {
    if (query.trim() === "") {
      setActive(false);
    }
  };

  const handleClear = () => {
    setQuery("");
    onSearch("");
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  //   return active ? (
  return (
    <div className="relative">
      <span className="absolute inset-y-0 left-0 flex items-center pl-2">
        <SearchOutlinedIcon className="text-gray-500" />
      </span>
      <input
        ref={inputRef}
        type="text"
        value={query}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder="Search"
        className="pl-10 pr-10 border border-gray-300 p-1 text-sm focus:outline-none focus:border-sss-info"
      />
      {query && (
        <button
          type="button"
          onClick={handleClear}
          className="absolute inset-y-0 right-0 flex items-center pr-2 text-gray-500 hover:text-red-500"
        >
          <CloseIcon className="w-4 h-4" />
        </button>
      )}
    </div>
  );
  //   ) : (
  //     <button
  //       onClick={handleIconClick}
  //       className="p-2 hover:bg-gray-100 hover:text-sss-info text-gray-700 active:bg-cyan-100 transition duration-100"
  //     >
  //       <SearchOutlinedIcon />
  //     </button>
  //   );
};

SearchInput.propTypes = {
  onSearch: PropTypes.func.isRequired,
};

export default SearchInput;
